export const qiankunWindow = window.proxy || window
export const RUNTIME_ENV = qiankunWindow.__app_env__.RUNTIME_ENV
export const HOST_ENV = qiankunWindow.__app_env__.HOST_ENV
export const HOSTS = qiankunWindow.__app_env__.HOSTS
export const SERVERS = qiankunWindow.__app_env__.SERVERS
export const ASSETS = qiankunWindow.__app_env__.ASSETS
export const ASSETS_BASE_URL = qiankunWindow.__app_env__.ASSETS_BASE_URL
export const IS_GREY = qiankunWindow.__app_env__.IS_GREY
export const SHELL_MODE = qiankunWindow.__app_env__.SHELL_MODE
